import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutDetail() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
          I am a Full-Stack developer based in Pune, India. I am  B.Sc Mathematics graduate from Solapur university
          . I am very passionate about improving my coding skills & developing applications & websites. 
          I build WebApps and Websites using MERN Stack.
           Working for myself to improve my skills. Love to build Full-Stack clones
            <br />
            Apart from coding, some other activities that I love to do!
            <br />
            <br />
            

            Drawing | Cooking | Singing Songs
          </p>
          

          
        </blockquote>
      </Card.Body>
    </Card>
  );
}
//https://socket.io/get-started/private-messaging-part-1/

export default AboutDetail;
